module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    },
    attrs: {
      "append-to-body": "",
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-row', {
    staticClass: "QueryForm"
  }, [_c('div', {
    staticClass: "el-col el-col-6"
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryForm.Name),
      expression: "queryForm.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.queryForm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryForm, "Name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "el-col el-col-12"
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("省/市/区")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryForm.Province),
      expression: "queryForm.Province"
    }],
    attrs: {
      "placeholder": "请选择省份"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryForm, "Province", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeProvince(_vm.queryForm.Province)
      }]
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "label": item.name
      },
      domProps: {
        "value": item.name
      }
    })
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryForm.City),
      expression: "queryForm.City"
    }],
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryForm, "City", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeCity(_vm.queryForm.City)
      }]
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "label": item.name
      },
      domProps: {
        "value": item.name
      }
    })
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryForm.Area),
      expression: "queryForm.Area"
    }],
    attrs: {
      "placeholder": "请选择县/区"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryForm, "Area", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "label": item.name
      },
      domProps: {
        "value": item.name
      }
    })
  }), 0)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm._getAllVeterans
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "selectVeteran",
    attrs: {
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('el-row', _vm._l((_vm.list), function(item, i) {
    return _c('el-col', {
      key: i,
      staticClass: "veteranCol",
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticClass: "veteranChecked"
    }, [_c('el-checkbox', {
      key: 'select_' + item.id,
      on: {
        "change": function($event) {
          return _vm.selectVeteran(item.id)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "veteranPhoto",
      attrs: {
        "title": "双击查看详情"
      },
      on: {
        "click": function($event) {
          return _vm.selectVeteran(item.id)
        },
        "dblclick": function($event) {
          $event.preventDefault();
          return _vm.seeDetail(item)
        }
      }
    }, [_c('img', {
      staticClass: "photo",
      attrs: {
        "src": item.photo
      }
    }), _vm._v(" "), (item.sex == 0 || item.sex == false) ? _c('img', {
      staticClass: "sex",
      attrs: {
        "src": "https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png"
      }
    }) : _c('img', {
      staticClass: "sex",
      attrs: {
        "src": "https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "veteranName",
      attrs: {
        "title": "双击查看详情"
      },
      on: {
        "dblclick": function($event) {
          $event.preventDefault();
          return _vm.seeDetail(item)
        },
        "click": function($event) {
          return _vm.selectVeteran(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name)), _c('span', [_vm._v(_vm._s(item.age) + "岁")])])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('veteranDetail', {
    ref: "veteranDetail"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9c570e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkout/components/SelectVeteran.vue
// module id = 772
// module chunks = 2